import React from "react";

const SECTION_CARDS = [
  { letter: "A", title: "Universal Opening", desc: "7 questions · Everyone" },
  { letter: "B", title: "Your Department", desc: "6 questions · Department-specific" },
  { letter: "C", title: "Data & Tech Readiness", desc: "5 questions · Everyone" },
  { letter: "D", title: "Strategic Intent", desc: "4 questions · Everyone" },
];

const Section1 = ({ onTakeSurvey, isLoading }) => {
  return (
    <section className="survey-landing">
      <div className="survey-landing-inner">
        <h1 className="survey-landing-title" data-aos="fade-up" data-aos-duration="900">
          Is Your Organization Ready for AI?<br />
          Find Out with Our{" "}
          <span className="yellow-txt">AI Readiness Index.</span>
        </h1>

        <p
          className="survey-landing-desc"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Answer 22–24 questions across 5 sections. We'll send a personalized AI
          Readiness Report to your work email showing exactly where you stand and
          what to prioritize first.
        </p>

        <div
          className="survey-landing-badges"
          data-aos="fade-up"
          data-aos-duration="1050"
        >
          <span className="survey-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            6–8 minutes
          </span>
          <span className="survey-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            USA Market
          </span>
          <span className="survey-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            Free AI Readiness Report
          </span>
        </div>

        <button
          className="survey-start-btn"
          onClick={onTakeSurvey}
          disabled={isLoading}
          data-aos="fade-up"
          data-aos-duration="1100"
        >
          {isLoading ? "Loading…" : "Take Survey →"}
        </button>

        <div
          className="survey-sections-preview"
          data-aos="fade-up"
          data-aos-duration="1200"
        >
          <p className="preview-heading">WHAT'S INCLUDED</p>
          <div className="preview-cards">
            {SECTION_CARDS.map((card) => (
              <div className="preview-card" key={card.letter}>
                <span className="preview-card-letter">{card.letter}</span>
                <div className="preview-card-info">
                  <strong>{card.title}</strong>
                  <span>{card.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section1;
